import { useEffect, useState } from 'react';
import { camelize } from 'utility/Utils';
import { getBinnacleService } from '../services';

const useGetBinnacle = (
  entityTypeId: number | undefined,
  entityId: number | undefined,
  execute: boolean
): {
  binnacleList: any;
  isFetchingBinnacle: boolean;
} => {
  const [binnacleList, setData] = useState<any>([]);
  const [isFetchingBinnacle, setIsFetching] = useState<boolean>(false);
  useEffect(() => {
    if (entityTypeId && entityId) {
      setIsFetching(true);
      getBinnacleService(
        {
          entityTypeId,
          entityId
        },
        {
          errorAction: () => {
            setData([]);
            setIsFetching(false);
          },
          successAction: (response) => {
            if (response) {
              // Merge binnacle and auditBinnacle arrays
              const auditBinnacle = camelize(response.data.auditBinnacle);
              const binnacle = camelize(response.data.binnacle);
              const fullBinnacle = binnacle.concat(auditBinnacle);

              // Sort by audit date (ascending)
              const fullBinnacleSorted = fullBinnacle.sort(
                (a, b) => new Date(a.AuditDate).getTime() - new Date(b.AuditDate).getTime()
              );

              setData(fullBinnacleSorted);
            } else setData([]);
            setIsFetching(false);
          }
        }
      );
    }
  }, [execute]);
  return { binnacleList, isFetchingBinnacle };
};

export default useGetBinnacle;
